/* storybook-check-ignore */
import { Flex, Text, Box } from '@opendoor/bricks/core';
import { ListingWithComputedProperties } from 'declarations/exclusives/listing';
import { getIsSellerOfferExperiment } from 'helpers/exclusives/listing';
import moment from 'moment-timezone';
import { ListingStates } from '../constants/constants';

const FINAL_STATES = [ListingStates.EL_SOLD, ListingStates.EL_IN_CONTRACT];

export default function WithPriceAdditionalStateInfo({
  listing,
}: {
  listing: ListingWithComputedProperties;
}) {
  const elState = listing.el_state;
  if (!FINAL_STATES.includes(elState) || getIsSellerOfferExperiment(listing)) return null;
  return (
    <>
      <Flex
        flexWrap="wrap"
        justifyContent="space-between"
        pr={[null, null, null, '15%']}
        maxWidth="697px"
      >
        <Box>
          <Box display="flex" flexDirection="row" alignItems="baseline">
            <Text margin="0" mr="0.25rem" color="inherit" fontSize="s00" fontWeight="semibold">
              {elState === ListingStates.EL_IN_CONTRACT ? 'In contract on' : 'Purchased on'}
            </Text>
          </Box>

          <Flex alignItems="center">
            <Text
              margin="0"
              pr="0.2rem"
              fontSize="s3"
              lineHeight="s3"
              fontWeight="bold"
              color="neutrals90"
            >
              {elState === ListingStates.EL_IN_CONTRACT
                ? moment(listing.pending_date).format('MMM DD, YYYY')
                : moment(listing.close_date).format('MMM DD, YYYY')}
            </Text>
          </Flex>
        </Box>
      </Flex>
      {elState === ListingStates.EL_SOLD && (
        <>
          <Text
            fontSize="s1"
            lineHeight="s1"
            fontWeight="semibold"
            mt={['1.5rem', '1.5rem', '1.5rem', '3rem']}
          >
            This home was sold.
          </Text>
          <Text fontSize="s0" lineHeight="s0" mt={4}>
            This home was sold and is no longer available to purchase.
          </Text>
        </>
      )}

      {elState === ListingStates.EL_IN_CONTRACT && (
        <>
          <Text
            fontSize="s1"
            lineHeight="s1"
            fontWeight="semibold"
            mt={['1.5rem', '1.5rem', '1.5rem', '3rem']}
          >
            Pending exclusive off-market sale
          </Text>
          <Text fontSize="s0" lineHeight="s0" mt={4}>
            Add to watchlist to get notified if this home becomes available to purchase.
          </Text>
        </>
      )}
    </>
  );
}
